import { PiensoApp } from "./interfaces";
import { NavigationItem, NavigationChildItem } from "@ui";

export interface NavChildItem extends NavigationChildItem {
  role?: string;
  requiredApp?: PiensoApp;
}

export interface NavItem extends NavigationItem {
  role?: string;
  requiredApp?: PiensoApp;
  children?: NavChildItem[];
}

export const NAV_CONFIG: NavItem[] = [
  {
    id: "home",
    label: "Home",
    icon: "home",
    route: "/core/home",
    role: "home:full",
  },
  {
    id: "ingest",
    label: "Ingest",
    icon: "upload-cloud",
    route: "/ingest/library",
    role: "ingest:full",
  },
  {
    id: "train",
    label: "Train",
    icon: "model-magic",
    route: "/core/lenses",
    children: [
      {
        id: "train.training-data",
        label: "Training Data",
        icon: "data-model",
        description: "Data ready to be used for training fingerprint and deep learning models",
        route: "/core/trainingData",
        role: "train:training_data:full",
      },
      {
        id: "train.fingerprinting",
        label: "Fingerprinting",
        icon: "fingerprint",
        description: "Create custom fingerprint models to identify unique patterns in your data",
        route: "/core/lenses",
        role: "train:fingerprinting:full",
      },
      {
        id: "train.deep-learning",
        label: "Deep Learning",
        route: "/core/dl",
        icon: "graph-deep-learning",
        description: "Train deep learning models on your datasets to extract insights and predictions",
        role: "train:deep_learning:full",
      },
      {
        id: "train.training-workspace",
        label: "Training",
        route: "/core/lenses",
        role: "train:fingerprinting:full",
        visible: false,
      },
      {
        id: "train.dl-workspace",
        label: "Deep Learning",
        route: "/core/dl",
        icon: "graph_deep_learning",
        role: "train:deep_learning:full",
        visible: false,
      },
    ],
  },
  {
    id: "analyze",
    label: "Analyze",
    icon: "chart",
    route: "/explore/browse/explorations",
    children: [
      {
        id: "analyze.explore",
        label: "Explore",
        icon: "compass",
        description: "Use LLM's and other models to get insights on your data sets",
        route: "/explore/browse/explorations",
        role: "analyze:explore:full",
        requiredApp: "EXPLORE",
      },
      {
        id: "analyze.monitor",
        label: "Monitor",
        icon: "activity",
        description: "Monitor data feeds and enrichment pipelines",
        route: "/monitor",
        role: "analyze:monitor:full",
        requiredApp: "MONITOR",
      },
      {
        id: "analyze.dashboards",
        label: "Dashboards",
        icon: "dashboard",
        description: "Create custom monitoring views for your live deployments",
        route: "/analysis/monitor",
        role: "analyze:dashboards:full",
        requiredApp: "ANALYSIS",
      },
      {
        id: "analyze.dataset-analysis",
        label: "Data Set Analysis",
        icon: "analytics",
        description: "Use your fingerprint models to analyze any dataset",
        route: "/core/units",
        role: "analyze:data_set_analysis:full",
        requiredApp: "ANALYSIS",
      },
    ],
  },
  {
    id: "deploy",
    label: "Deploy",
    icon: "globe",
    route: "/analysis/deploy",
    role: "deploy:full",
  },
];
